import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import apiClient from "api/client";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {AxiosHeader} from "../../functions/GlobalFunctions";

class DropDownEventMultiCategory extends Component {

    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            eventCategory: []
        };
    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidMount() {

        if (AxiosHeader.getConfig() !== null) {

            const url = process.env.REACT_APP_API_URL + "/LiveEvent/categories";
            apiClient.get(url, AxiosHeader.getConfig())
                .then(res => {
                    const eventCategory = res.data;
                    const loading = false;
                    this.setState({eventCategory, loading});
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);

                });

        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }
    }

    render() {
        return (
            <Select
                placeholder="Event Category Select"
                name="categorySelect"
                autoFocus={false}
                multi={true}
                isSearchable={true}
                disabled={this.props.disabled}
                value={this.props.categorySelected}
                options={this.state.eventCategory}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownEventMultiCategory = connect(mapStateToProps)(DropDownEventMultiCategory);
const connectedDropDownEventMultiCategoryTrans = withNamespaces('common')(connectedDropDownEventMultiCategory);
export {connectedDropDownEventMultiCategoryTrans as DropDownEventMultiCategory};

